import { environment } from '../../environments/environment';

const API_URL = environment.apiUrl;

export const AUTHENTICATION_URL = `${API_URL}/login`;
export const AUTHENTICATION_PORTAL_URL = `${API_URL}/login-portal`;
export const VALIDATION_PORTAL_LOGIN_URL = `${API_URL}/login-portal/validation`;

const VACATIONS_ABSENCES_ROOT = 'vacations-absences';
export const VACATIONS_ABSENCES_URLS = {
  EMPLOYEE_ROOT: `${VACATIONS_ABSENCES_ROOT}/employee`,
  MANAGER_ROOT: `${VACATIONS_ABSENCES_ROOT}/manager`,
} as const;

export const LOANS_URLS = {
  ROOT: 'loans',
  CREDITWORTHINESS_ROOT: 'creditworthiness',
  MODALITIES_ROOT: 'modalities',
  SIGN_UP_ROOT: 'signup',
  MY_LOANS_ROOT: 'list',
  REPAYMENT_ROOT: 'amortizations',
  SIMULATION_ROOT: 'simulate',
  CADASTRAL_REFERENCE: 'cadastral-references',
  FAMILIES: 'families-purposes',
  EURIBOR: 'euribor',
  WAGE_ADVANCE_REASONS_LIST: 'wages-advance/reasons-list',
  WAGE_ADVANCE_EMPLOYEE: 'wages-advance',
  SERVICE_CLOSED: 'service-and-payroll-closure-date',
  SIGN_UP: 'signup',
  FIXED_SV: 'interest-fixed-sv',
  FIXED_VC: 'interest-fixed-vc',
} as const;

const FOOD_BENEFIT_ROOT = 'food-benefit';
export const FOOD_BENEFIT_URLS = {
  EMPLOYEE_ROOT: `${FOOD_BENEFIT_ROOT}/employee`,
  MANAGER_ROOT: `${FOOD_BENEFIT_ROOT}/manager`,
} as const;

const DELEGATIONS_ROOT = 'delegations';
export const DELEGATIONS_URLS = {
  ROOT: DELEGATIONS_ROOT,
  DELEGABLE_EMPLOYEES: `${DELEGATIONS_ROOT}/load-delegable-employees`,
} as const;

const MANAGER_FOR_EMPLOYEE_ROOT_URL = 'users';
export const MANAGER_FOR_EMPLOYEE_URL = {
  ROOT_MANAGER_FOR_EMPLOYEE: `${MANAGER_FOR_EMPLOYEE_ROOT_URL}/obtain-manager-for-employee`,
} as const;

const SOLIDARITY_ROOT_URL = 'euro-solidarity';
export const SOLIDARITY_URLS = {
  ROOT: SOLIDARITY_ROOT_URL,
  ONG_LIST: 'ong',
  CONTRIBUTIONS: 'contributions',
} as const;

const SOCIAL_SECURITY_ROOT = 'social-security';
export const SOCIAL_SECURITY_URLS = {
  ROOT: SOCIAL_SECURITY_ROOT,
  QUOTE_BASIS_INITIAL: 'quote-basis-initial',
} as const;
